import {HttpService} from "../../../common/api/httpService";
import {PaymentMethodModel} from "../../../models/paymentMethod";

export class PaymentMethodsApi {
    private static httpService = HttpService.getInstance();

    static async getPaymentMethods(): Promise<PaymentMethodModel[]> {
        try {
            const result = await this.httpService.adminFetch('paymentMethods/list');
            if (result.result && result.value) {
                return result.value as PaymentMethodModel[];
            }
            return [];
        } catch (error) {
            console.error('Error fetching payment methods:', error);
            return [];
        }
    }

    static async getPaymentMethod(id: number): Promise<PaymentMethodModel | null> {
        try {
            const result = await this.httpService.adminFetch(`paymentMethods/${id}`);
            if (result.result && result.value) {
                return result.value as PaymentMethodModel;
            }
            return null;
        } catch (e) {
            console.error('Error fetching payment method by id:', e);
            return null;
        }
    }

    private static toMultipartMap(model: Partial<PaymentMethodModel>): Map<string, any> {
        const data = new Map<string, any>();
        for (const key in model) {
            if (!Object.prototype.hasOwnProperty.call(model, key)) continue;
            const value = (model as any)[key];
            if (value === undefined || value === null) continue;
            data.set(key, value);
        }
        return data;
    }

    static async createPaymentMethodForm(model: Partial<PaymentMethodModel>, file?: File): Promise<boolean> {
        try {
            const data = this.toMultipartMap(model);
            const result = await this.httpService.multipartRequestAsync('admin/paymentMethods', data, 'POST', file ? [{file: file, name: 'File'}] : undefined);
            return result.ok;
        } catch (e) {
            console.error('Error creating payment method:', e);
            return false;
        }
    }

    static async updatePaymentMethodForm(model: Partial<PaymentMethodModel>, file?: File): Promise<boolean> {
        try {
            const data = this.toMultipartMap(model);
            const result = await this.httpService.multipartRequestAsync('admin/paymentMethods', data, 'PUT', file ? [{file: file, name: 'File'}] : undefined);
            return result.ok;
        } catch (e) {
            console.error('Error updating payment method:', e);
            return false;
        }
    }

    static async deletePaymentMethod(id: number): Promise<boolean> {
        try {
            const result = await this.httpService.adminFetch(`paymentMethods/${id}`, 'DELETE');
            return !!result.result;
        } catch (e) {
            console.error('Error deleting payment method:', e);
            return false;
        }
    }
}
